/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/RelatedProducts/RelatedProducts',[
    'jquery',
    'global/all',
    'plugins/slick'
], function ($, Roc, Slick) {
    'use strict';

    function init() {
        $('.cardSlider.carousel').slick({
            slidesToShow: 6,
            centerPadding: "60px",
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                        infinite: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        infinite: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    };
    
    var RelatedProducts = {
        init: init
    };

    Roc.Logger.debug('RelatedProducts.js Loaded:', RelatedProducts);

    return RelatedProducts;
});
